import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/gatsby';
import Axios from '../../utils/Axios';
import { FeatureFlag, FeatureFlagName } from '../../@types/FeatureFlag';
import { State } from '../index';

export const fetchPasswordlessMagicLinkEnabled = createAsyncThunk<
  FeatureFlag,
  void,
  { rejectValue: string; state: State }
>(
  'featureFlags/fetchPasswordlessMagicLinkEnabled',
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        '/feature-flags/passwordless_magic_link_enabled',
      );
      return response.data;
    } catch (error: any) {
      Sentry.captureException(error);
      const val = error.message || error;
      return rejectWithValue(val);
    }
  },
  {
    condition: (_, { getState }) => {
      const { featureFlags } = getState();

      if (featureFlags.loading) {
        return false;
      }

      const existingFlag = featureFlags.featureFlags.find(
        (f) => f.name === FeatureFlagName.passwordless_magic_link_enabled,
      );

      if (existingFlag && featureFlags.lastFetched) {
        const thirtyMinutesInMs = 30 * 60 * 1000;
        const timeSinceLastFetch = Date.now() - featureFlags.lastFetched;
        if (timeSinceLastFetch < thirtyMinutesInMs && timeSinceLastFetch >= 0) {
          return false;
        }
      }

      return true;
    },
  },
);
